
// src/reducers/user-settings-reducer.js

import { 
  OPEN_USER_SETTINGS_PAGE,
  CLOSE_USER_SETTINGS_PAGE,
} from '../actions/user-settings'

const initialState = {
  name: undefined,
  active: false,
}

export default function userSettingsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case OPEN_USER_SETTINGS_PAGE:
    return Object.assign({}, state, {
      name: action.name,
      active: true,
    })

  case CLOSE_USER_SETTINGS_PAGE:
    return Object.assign({}, state, {
      name: undefined,
      active: false,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user-settings-reducer.js